/**
 * @fileoverview Three-step "how it works" section — Set up → Score →
 * Share. Each card uses the same palette-driven wash recipe as the
 * features grid so all three sections feel like one visual family.
 *
 * Extracted verbatim out of the original Landing/index.tsx.
 */
import { Badge } from '@/components/ui/badge'
import { STEPS } from '../constants'

export function HowItWorks() {
  return (
    <section id="how-it-works" className="relative border-y border-primary/10 overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary/[0.08] via-primary/[0.02] to-transparent dark:from-primary/[0.12] dark:via-primary/[0.04] dark:to-transparent"
      />
      <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Badge variant="outline" className="mb-3">Workflow</Badge>
          <h2 className="text-balance text-3xl font-bold tracking-tight sm:text-4xl">
            From schedule to scorecard in three steps
          </h2>
        </div>

        <div className="mt-14 grid gap-8 lg:grid-cols-3">
          {STEPS.map((s) => {
            const Icon = s.icon
            return (
              <div
                key={s.number}
                className="relative overflow-hidden rounded-2xl border border-primary/10 bg-white p-6 shadow-sm dark:bg-card"
              >
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary/[0.08] via-primary/[0.02] to-transparent"
                />
                <div className="relative">
                  <div className="mb-5 flex items-center gap-3">
                    <span className="text-3xl font-bold text-primary/40 tabular-nums">{s.number}</span>
                    <div className="rounded-lg bg-primary/10 p-2 text-primary">
                      <Icon className="h-5 w-5" />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                    {s.description}
                  </p>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
